import squid from '../assets/squid.png'
import hotel  from '../assets/hotel.png'
import project from '../assets/project.png'
import circle from '../assets/circle.png'
import longW from '../assets/long-w.png'
import { motion } from 'framer-motion'

const Portfolio = () => {
    const portImg = [
        squid,hotel,project
    ]

    const variants = {
        hidden: { opacity: 0, y: 75 },
        visible: { opacity: 1, y: 0 },
    }

    return (
        <motion.div 
            id='project' 
            className="relative py-20 px-8 tab:px-4"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.2 }} 
            variants={variants}
            transition={{ duration: 0.8 }}
        >

            <h2 className="text-white text-4xl font-bold mb-12">
                Our Awesome Portfolio
            </h2>

            <img 
                src={circle} 
                alt="circle" 
                className='absolute right-10 top-16 w-10'
            />

            <img 
                src={longW} 
                alt="circle" 
                className='absolute left-10 bottom-10 w-16'
            />

            <motion.div 
                className='flex flex-wrap justify-center items-center gap-16 mb-10'
                initial= 'hidden'
                whileInView="visible"
                viewport={{ once: true, }}
                variants={variants}
                transition={{ duration: 0.5, delay: 0.5 }}
            >

                {
                    portImg.map((img, index) => (
                        <motion.img 
                            key={index}
                            src={img} 
                            alt="Img" 
                            className='animi w-96 cursor-pointer hover:shadow-2xl'
                            initial= 'hidden'
                            whileInView="visible"
                            viewport={{ once: true, }}
                            variants={{
                                hidden: { opacity: 0, y: 75 },
                                visible: { opacity: 1, y: 0 }
                            }}
                            transition={{ duration: 0.5 }}  
                        />
                    ))
                }

            </motion.div>

        </motion.div>
    );
}
 
export default Portfolio;